<header class="h-12 flex items-center px-4 gap-2 border-b border-border bg-header">
  <button (click)="toggleDrawer.emit()" class="text-sm py-1 px-2 text-muted rounded-lg hover:bg-surface hover:text-foreground">
    @if (isDrawerOpen()) {
      <span class="fas fa-angles-left"></span>
    } @else {
      <span class="fas fa-angles-right"></span>
    }
  </button>
  @if (showWarehouseHome()) {
    <a [routerLink]="path.warehouse | absoluteRoute" class="text-sm py-1 px-2 text-muted rounded-lg hover:bg-surface hover:text-foreground">
      <span class="fas fa-warehouse"></span>
    </a>
  }
  <div class="border-l h-4 border-border"></div>
  <nav class="flex items-center gap-1 text-sm text-muted">
    @for (item of breadcrumbItems(); track item.label; let last = $last) {
      @if (item.route) {
        <a [routerLink]="item.route" class="hover:text-foreground transition-colors">
          {{ item.label | translate }}
        </a>
      } @else {
        <span [class]="last ? 'text-foreground font-medium' : ''">
          {{ item.label | translate }}
        </span>
      }
      @if (!last) {
        <span class="text-border">/</span>
      }
    }
  </nav>
  @if (isDevEnv) {
    <div class="ml-auto">
      <app-theme-switcher />
    </div>
  }
</header>
